import { useEffect } from "react";
import { defaultSEO } from "@/mocks/seo";

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
}

export default function SEOHead({
  title = defaultSEO.title,
  description = defaultSEO.description,
  keywords = defaultSEO.keywords,
  canonicalUrl = defaultSEO.canonicalUrl,
  ogType = "website",
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);

    const canonical = document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (canonical) {
      canonical.href = canonicalUrl;
    }

    setMeta("og:type", ogType, true);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:url", canonicalUrl, true);

    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
  }, [title, description, keywords, canonicalUrl, ogType]);

  return null;
}